/* storybook-check-ignore */
import AccountFormPage from 'components/exclusives/ExclusivesAccountFormPage';
import { useMemo, useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { Flex, Text } from '@opendoor/bricks/core';

function getDiffToEndTimeAsDuration(endTime: moment.Moment) {
  const diffInMs = endTime.diff(moment());
  return diffInMs < 0 ? moment.duration(0) : moment.duration(diffInMs, 'milliseconds');
}

const DURATION_UNTIL_SELECTION_EXPIRATION = { minutes: 10 };

export default function ReserveATourAuthentication({
  onLogin,
  onSelectionExpired,
}: {
  onLogin: () => void;
  onSelectionExpired: () => void;
}) {
  const timeToExpiration = useMemo(() => moment().add(DURATION_UNTIL_SELECTION_EXPIRATION), []);
  const [timeLeft, setTimeLeft] = useState(getDiffToEndTimeAsDuration(timeToExpiration));
  useEffect(() => {
    if (timeToExpiration && (!timeLeft || timeLeft.asMilliseconds())) {
      const timeout = setTimeout(() => {
        setTimeLeft(getDiffToEndTimeAsDuration(timeToExpiration));
      }, 1000);
      return () => clearTimeout(timeout);
    }
    onSelectionExpired();
    return () => undefined;
  }, [timeToExpiration, timeLeft]);
  return (
    <>
      <Flex
        border="1px solid"
        borderColor="neutrals40"
        width="100%"
        left="0"
        borderRadius="roundedSquare"
        position="sticky"
        top="0"
        background="neutrals10"
        height="3rem"
        alignItems="center"
        justifyContent="center"
        gridGap="0.5rem"
      >
        <ClockIcon />
        <Text>
          Tour times saved for{' '}
          <Text as="span" fontWeight="semibold">
            {timeLeft.format('mm:ss')}
          </Text>
        </Text>
      </Flex>
      <AccountFormPage
        loginHeaderText="Sign in to tour this home"
        loginSubHeaderText="Sign in or create an account"
        onSubmit={onLogin}
        boxProps={{ mt: 0, mb: 0, pt: [0, 0, 7] }}
      />
    </>
  );
}

function ClockIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="6.375"
        y="3.375"
        width="0.75"
        height="4.25"
        rx="0.375"
        fill="#8292A2"
        stroke="#6E6E6E"
        strokeWidth="0.75"
      />
      <rect
        x="6.375"
        y="7.625"
        width="0.75"
        height="3.25"
        rx="0.375"
        transform="rotate(-90 6.375 7.625)"
        fill="#8292A2"
        stroke="#6E6E6E"
        strokeWidth="0.75"
      />
      <circle cx="7" cy="7" r="6" stroke="#6E6E6E" strokeWidth="2" />
    </svg>
  );
}
